import { Pipe, PipeTransform } from '@angular/core';
import { forEach } from 'lodash-es';

@Pipe({
  name: 'tableScroll'
})
export class TableScrollPipe implements PipeTransform {

  transform(value: string): any {
    const div = document.createElement('div');
    div.innerHTML = value;
    const tables = div.querySelectorAll('table');
    forEach(tables, table=>{
      const wrapper = table.parentElement;
      if (wrapper.getAttribute('class') && wrapper.getAttribute('class').includes('x-scroll-wrapper')) return;
      this.wrapInXScroller(table);
    });
    const value_modified = div.innerHTML;
    
    // ie11 does not support remove
    // div.remove(); 
    // ie11 does not support remove

    return value_modified;
  }
  wrapInXScroller (el:HTMLElement) {

    // create wrapper container
    const wrapper = document.createElement('div');
    wrapper.setAttribute('class', 'x-scroll-wrapper');
    wrapper.style['width'] = '100%';
    wrapper.style['overflow-x'] = 'scroll';
    wrapper.style['overflow-y'] = 'auto';
    
    // insert wrapper before el in the DOM tree
    el.parentNode.insertBefore(wrapper, el);
    
    // move el into wrapper
    wrapper.appendChild(el);    
  }
}
